import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { askQuestions } from '@/mocks/home';

export default function AskGreenSide() {
  const [q, setQ] = useState('');
  const [asked, setAsked] = useState('');

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (q.trim()) setAsked(q.trim());
  };

  return (
    <section className="bg-primary-500 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block bg-accent-500 text-foreground-950 font-label font-bold uppercase text-xs tracking-widest px-3 py-1 rounded-sm">AI assistant, preview</span>
        <h2 className="font-heading font-bold text-4xl md:text-6xl text-background-50 leading-[1.02] mt-4">Ask GreenSide</h2>
        <form onSubmit={onSubmit} className="mt-8 flex flex-col sm:flex-row bg-background-50 rounded-lg sm:rounded-full p-2 gap-2">
          <div className="flex items-center flex-1 px-3">
            <span className="w-5 h-5 flex items-center justify-center text-foreground-500"><i className="ri-search-line"></i></span>
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ask about local events, courses or stories" className="flex-1 text-sm px-3 py-3 bg-transparent focus:outline-none" />
          </div>
          <button type="submit" className="bg-foreground-950 hover:bg-foreground-800 text-background-50 font-label font-bold uppercase tracking-wider px-6 py-3 rounded-full whitespace-nowrap cursor-pointer">Ask</button>
        </form>
        <div className="mt-5 flex flex-wrap justify-center gap-2">
          {askQuestions.map((s) => (
            <button key={s} type="button" onClick={() => { setQ(s); setAsked(s); }} className="bg-primary-600 hover:bg-primary-700 border border-primary-400 text-background-50 text-sm px-4 py-2 rounded-full cursor-pointer text-left">{s}</button>
          ))}
        </div>
        {asked && (
          <div className="mt-6 bg-background-50 rounded-lg p-5 text-left">
            <p className="font-label uppercase text-xs tracking-widest text-foreground-500">You asked</p>
            <p className="font-heading font-bold text-xl text-foreground-950 mt-1">{asked}</p>
            <p className="text-sm text-foreground-700 mt-3">The GreenSide assistant is in preview and not answering live yet. Meanwhile, browse the <Link to="/#calendar" className="text-primary-600 underline cursor-pointer">events calendar</Link> or <Link to="/#news" className="text-primary-600 underline cursor-pointer">latest stories</Link>.</p>
          </div>
        )}
      </div>
    </section>
  );
}